import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { ApiService } from "../api.service";
import { ConsultRequestSummary } from "./model/ConsultRequestSummary";
import { ConsultRequestSummaryData } from "./model/ConsultRequestSummaryData";
import { SalesManager } from "./model/SalesManager";

@Injectable()
export class ConsultingMonitoringService {
    constructor(private apiService: ApiService) { }

    public getConsultRequestSummaryByUsers(queryId: string, callback?: (value: ConsultRequestSummary) => void): Subscription {
        
        let url: string = "user/sales/consult/" + queryId;


        return this.apiService.getInnerTargetApi(url, null, (value: Object) => {
            if (callback && value) {
                let summary: ConsultRequestSummary = new ConsultRequestSummary(value);
                callback(summary);
            }
        });
    }
    
}


// WEBPACK FOOTER //
// ./src/app/services/sales/consulting-monitoring.service.ts